import "./ResetEmailSuccessComponent.scss";
import {  useSearchParams } from "react-router-dom";
import { useCallback, useState } from "react";
import { motion } from "framer-motion";
import commonService from "../../../services/common.service.ts";
import { Button } from "@/components/ui/button.tsx";
import {buttonVariants, containerVariants} from "@/constants/animations.ts";


const ResetEmailSuccessComponent = () => {
    const [submitting, setSubmitting] = useState(false);
    const [searchParams] = useSearchParams();
    const email = searchParams.get("email");

    const onSubmit = useCallback(() => {
        setSubmitting(true);
        commonService._account
            .sendResetPasswordEmail({ email })
            .then(() => {
                setSubmitting(false);
                // commonService._alert.showToast('Reset password email sent successfully', 'success')
            })
            .catch(() => {
                // commonService._alert.showToast(error.detail, 'error')
                setSubmitting(false);
            });
    }, [email]);

    return (
        <motion.div
            className={"reset-email-success-component main-auth-card screen"}
            variants={containerVariants}
            initial="hidden"
            animate="visible"
        >
            <motion.div className={"auth-screen-title-wrapper"} variants={containerVariants}>
                <div className={"auth-screen-title"}>Email Sent</div>
                <motion.div className={"auth-screen-subtitle  text-secondary-foreground mt-1"} variants={containerVariants}>
                    Please check the email address for instructions to<br /> reset your password.
                </motion.div>
            </motion.div>
            <motion.div variants={buttonVariants} whileHover="hover">
                <Button
                    type={"button"}
                    fullWidth={false}
                    loading={submitting}
                    variant={"text"}
                    className={'mrg-top-20'}
                    onClick={onSubmit}
                    mixpanelEvent={{
                        name: "reset_email_resend_clicked",
                        properties: {}
                    }}
                >
                    Resend email
                </Button>
            </motion.div>
        </motion.div>
    );
};

export default ResetEmailSuccessComponent;
